(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["flappie-localization"] && !Shopify.designMode) return;
  try {
    (() => {
    const dialog = document.getElementById('FlappieLocalization');
    const template = document.getElementById('FlappieLocalizationTrigger');
    if (!dialog || !template || typeof dialog.showModal !== 'function') return;
    const form = dialog.querySelector('form');
    const language = form.elements.language_code;
    const country = form.elements.country_code;
    const originalLanguage = language.value;
    const originalCountry = country.value;
    let returnFocus;
    let opening = false;
    let footerSource;

    async function open(button) {
      if (opening || dialog.open) return;
      opening = true;
      form.reset();
      returnFocus = button;
      const drawer = button.closest('menu-drawer');
      try {
        if (drawer?.open && typeof drawer.hide === 'function') {
          returnFocus = drawer.activeElement;
          await drawer.hide();
          await new Promise(resolve => setTimeout(resolve, 0));
        }
        dialog.showModal();
        document.documentElement.classList.add('fl-localization-open');
      } finally {
        opening = false;
      }
    }

    function enhance() {
      document.querySelectorAll('.topbar-section .localization, menu-drawer .drawer__footer-top, footer-group .localization').forEach(container => {
        if (!container.querySelector('[name="country_code"], [name="locale_code"]')) return;
        if (!container.querySelector('.fl-localization-trigger')) {
          const button = template.content.firstElementChild.cloneNode(true);
          button.addEventListener('click', () => open(button));
          container.append(button);
          container.classList.add('fl-localization-enhanced');
        }
        const socials = container.closest('footer-group')?.querySelector('.footer__socials');
        if (socials && !socials.contains(container)) {
          footerSource = { container, parent: container.parentNode, next: container.nextSibling };
          socials.append(container);
        }
      });
    }

    dialog.querySelector('[data-fl-localization-cancel]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('keydown', event => {
      if (event.key !== 'Tab') return;
      const last = form.querySelector('button[type="submit"]');
      if (event.shiftKey && document.activeElement === language) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        language.focus();
      }
    });
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => {
      form.reset();
      document.documentElement.classList.remove('fl-localization-open');
      if (returnFocus?.isConnected) returnFocus.focus();
    });
    form.addEventListener('submit', event => {
      if (language.value === originalLanguage && country.value === originalCountry) {
        event.preventDefault();
        dialog.close();
        return;
      }
      form.elements.return_to.value = window.location.pathname + window.location.search + window.location.hash;
    });
    window.addEventListener('pageshow', event => { if (event.persisted && dialog.open) dialog.close(); });
    document.addEventListener('shopify:section:unload', event => {
      if (!footerSource) return;
      const { container, parent, next } = footerSource;
      if (event.target.contains(container) || event.target.contains(parent)) {
        parent.insertBefore(container, next?.parentNode === parent ? next : null);
        footerSource = undefined;
      }
    });
    document.addEventListener('shopify:section:load', enhance);
    enhance();
  })();
  } catch(e) { console.error(e); }
})();

})();
